<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Detalle</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="tpi_edi" v-model="modelValue.tpi_edi" placeholder="Escriba...">
                        TPI
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="dimension_edi" v-model="modelValue.dimension_edi" placeholder="Escriba...">
                        Alto
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="dimension2_edi" v-model="modelValue.dimension2_edi" placeholder="Escriba...">
                        Ancho
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="int" id="pieza_edi" v-model="modelValue.pieza_edi" placeholder="Escriba...">
                        Cantidad
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="codigo_rep_edi" v-model="modelValue.codigo_rep_edi" placeholder="Escriba...">
                        Componente
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="repair_method_edi" v-model="modelValue.repair_method_edi" placeholder="Escriba...">
                        Método de Reparación
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="descripcion_edi" v-model="modelValue.descripcion_edi" placeholder="Escriba...">
                        Descripción
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="tipo_material_edi" v-model="modelValue.tipo_material_edi" placeholder="Escriba...">
                        Tipo de material
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="labour_rate_edi" v-model="modelValue.labour_rate_edi" placeholder="Escriba...">
                        Lb. Rate
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="handling_total_edi" v-model="modelValue.handling_total_edi" placeholder="Escriba...">
                        Handling total
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="tax_total_edi" v-model="modelValue.tax_total_edi" placeholder="Escriba...">
                        Total Tax	
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="horas_hombre_edi" v-model="modelValue.horas_hombre_edi" placeholder="Escriba...">
                        Horas hombres	
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="precio_edi" v-model="modelValue.precio_edi" placeholder="Escriba...">
                        Precio	
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="damage_code" v-model="modelValue.damage_code" placeholder="Escriba...">
                        Damage
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="localizacion_id_edi" v-model="modelValue.localizacion_id_edi" placeholder="Escriba...">
                        Localización
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field id="tipo_unidad" v-model="modelValue.tipo_unidad" placeholder="Escriba...">
                        Tipo unidad
                    </input-field>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button type="button" @click="aceptar" class="btn-success"><i class="fa fa-check"></i><span>Aceptar</span></button>
            <button type="button" @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: function () {
                return null;
            }
        }
    },
    data: function () {
        return {
            modelValue: JSON.parse(JSON.stringify(this.value)),
            decimal: decimal,
            int : int
        };
    },
    methods: {
        aceptar: function () {
            this.$emit('input', this.modelValue);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/sistema/Detalle.vue